// extracted by mini-css-extract-plugin
export default {"DialogContent":"📚19-10-2aHCsK"};